import { useMemo, useState } from 'react'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import InsumoHttp from '../../../../services/api/https/insumos/insumo.http'

export const LOADING_MESSAGES = {
  NONE: 'none',
  FETCHING: 'Obtendo as movimentações dos Insumos . . . ',
}

const ERROR_MESSAGE = {
  SELECT_TP: 'Selecione a Operação Logística',
}

const { dataInicial, dataFinal } = getPeriodoMesAtual()

const NEW_MOVIMENTACAO = {
  data_movimentacao: new Date(),
  insumo: '',
  operacao: '',
  qte: '',
}
const INIT_STATE = {
  loadingMessage: LOADING_MESSAGES.NONE,
  errorMessage: null,
  pInicial: dataInicial,
  pFinal: dataFinal,
  movimentacoes: [],
  showModal: false,
  insumos: [], // utilizado no MODAL
  operacoes: [], // utilizado no Modal
  selectedMovimentacao: null,
}

export default function useEntradaSaidaInsumo() {
  const [state, setState] = useState({ ...INIT_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      setLoadingMessageTo(loadingMessage) {
        setState(prevState => ({ ...prevState, loadingMessage }))
      },
      resetState() {
        setState(prevState => ({ ...prevState, errorMessage: null }))
      },
      getMovimentacoes(pInicial, pFinal, selectedTp) {
        InsumoHttp.getInitInfoMovimentacao(pInicial, pFinal, selectedTp)
          .then(result => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOADING_MESSAGES.NONE,
              movimentacoes: result.movimentacoes,
              insumos: result.insumos,
              operacoes: result.operacoes,
            }))
          })
          .catch(e => {
            setState(prevState => ({ ...prevState, errorMessage: e }))
          })
      },
      // Events
      onBtnNovoClick(selectedTp) {
        if (selectedTp === 0) {
          setState(prevState => ({ ...prevState, errorMessage: ERROR_MESSAGE.SELECT_TP }))
        } else {
          setState(prevState => ({
            ...prevState,
            showModal: true,
            selectedMovimentacao: { ...NEW_MOVIMENTACAO },
          }))
        }
      },

      onPeriodoChange(pInicial, pFinal) {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOADING_MESSAGES.FETCHING,
          pFinal,
          pInicial,
        }))
      },
      onModalResponse(action, payload) {
        if (action === 'close') {
          setState(prevState => ({ ...prevState, showModal: false }))
        } else if (action === 'error') {
          setState(prevState => ({ ...prevState, errorMessage: payload }))
        } else if (action === 'success') {
          setState(prevState => {
            prevState.movimentacoes.push(payload)
            return { ...prevState, showModal: false }
          })
        }
      },

      onSelectedTpChange(selectedTp) {
        if (selectedTp === 0) {
          setState(prevState => ({ ...prevState, errorMessage: ERROR_MESSAGE.SELECT_TP }))
        } else {
          setState(prevState => ({ ...prevState, loadingMessage: LOADING_MESSAGES.FETCHING }))
        }
      },

      onExcluir(movimento) {
        InsumoHttp.excluirMovimentoInsumo(movimento.movimentacao_id)
          .then(() => {
            setState(prevState => {
              prevState.movimentacoes = prevState.movimentacoes.filter(
                m => m.movimentacao_id !== movimento.movimentacao_id,
              )
              return { ...prevState }
            })
          })
          .catch(e => {
            setState(prevState => ({ ...prevState, errorMessage: e }))
          })
      },
    }
  }, [])

  return { state, localDispatch }
}
